/**
 * Compute a tight Y-axis domain with padding around actual data range.
 * Returns undefined for empty data (let Recharts auto-scale).
 */
export function computeChartDomain(
    values: number[],
    paddingPercent = 0.05
): [number, number] | undefined {
    const filtered = values.filter((v) => v != null && isFinite(v));
    if (filtered.length === 0) return undefined;

    const min = Math.min(...filtered);
    const max = Math.max(...filtered);
    const range = max - min;

    if (range === 0) {
        // Flat line — add ±2% of absolute value, minimum ±1
        const pad = Math.max(Math.abs(min) * 0.02, 1);
        return [min - pad, max + pad];
    }

    const pad = range * paddingPercent;
    return [min - pad, max + pad];
}
